/** @jsxImportSource @emotion/react */
import React from 'react';
import type { DivProps } from 'typings';
import { UDButton, UDText } from 'ud-ui/components';
import PlusIcon from 'ud-ui/components/icon/plus-icon';
import ScreenFullFilledIcon from 'ud-ui/components/icon/screen-full-filled-icon';
import UDTippy from 'ud-ui/components/tippy';
import * as S from './styles';

interface IProps extends DivProps {
  icon?: React.ReactNode;
  header?: string;
  buttonText?: string;

  isShowButton?: boolean;
  onClickButton?: () => void;
  onClickExtend?: () => void;

  loading?: boolean;
}

function Section(props: IProps) {
  const { children, icon, header, buttonText, onClickExtend, onClickButton, isShowButton, loading, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <UDTippy content={'Подробнее'} placement={'top'}>
        <S.ExpandButtonWrapper variant="primary" onClick={onClickExtend} disabled={loading}>
          <ScreenFullFilledIcon />
        </S.ExpandButtonWrapper>
      </UDTippy>
      <div className="flex items-center gap-3">
        <S.IconWrapper>{icon}</S.IconWrapper>
        <UDText isNew type="title-1">
          {header}
        </UDText>
      </div>
      {!loading ? <div className="flex flex-1 flex-col">{children}</div> : <div className="skeleton-block flex flex-1" />}
      <UDButton
        variant="primary"
        className="flex-center gap-2"
        style={{
          display: isShowButton && !loading ? undefined : 'none',
        }}
        onClick={onClickButton}
      >
        <PlusIcon />
        {buttonText}
      </UDButton>
    </S.MainBlock>
  );
}

export default Section;
